// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.0034 18.4186L23 0.000732422L10.001 0.0019865V2.00199L21 2.00129V16.4152L23.0034 18.4186Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 4H3V23.9432L11 18.2289L19 23.9432V4Z"}}]};

const BookmarkDoubleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bookmark-double-filled',
    ref,
    icon: element,
  },
));

BookmarkDoubleFilledIcon.displayName = 'BookmarkDoubleFilledIcon';

export default BookmarkDoubleFilledIcon;
